import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleDown } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import {
  ContainerBox,
  Header,
  Body,
  OrangeButton,
  Title,
  Container,
  CardHeader,
  CardHeaderTitle,
  FormGroup,
  InsideFormGroup,
  Input,
} from "../components/DefaultImports";

const DropDownButtonLeft = styled.div`
  padding: 0;
  display: flex;
  height: 100%;
  width: 70%;
  align-items: center;
  justify-content: center;
  border-right: 1px solid gray;
  cursor: pointer;
  color: ${(props) => (props.isPeopleAndZero ? "black" : "gray")};
  font-size: 13px;
  background-color: ${(props) => (props.isPeopleAndZero ? "#EE754C" : "white")};
  border-radius: 5px 0 0 5px;
`;

const DropDownButtonRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: gray;
  text-align: center;
  width: 30%;
  cursor: pointer;
  background-color: white;
  border-radius: 0 5px 5px 0;
`;

const DropDownButton = ({ options, unit, setUnit }) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedRef = useRef(null);

  useEffect(() => {
    if (isOpen && selectedRef.current) {
      selectedRef.current.scrollIntoView({ block: "center" });
    }
  }, [isOpen]);

  const handleSelect = (option, e) => {
    e.preventDefault();
    setUnit(option);
    setIsOpen(false);
  };

  const handleOpen = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  return (
    <div className="form-control-people ms-1" onClick={(e) => handleOpen(e)}>
      <DropDownButtonLeft>{unit}</DropDownButtonLeft>
      <DropDownButtonRight>
        <div className={`arrow-icon ${isOpen ? "rotate-menu-arrow" : ""}`}>
          <FontAwesomeIcon
            icon={faChevronCircleDown}
            size="xl"
            color="#EE754C"
          />
        </div>
      </DropDownButtonRight>

      {isOpen && (
        <div className="custom-dropdown-menu">
          {options.map((option, index) => (
            <div
              className={`dropdown-menu-item ${
                option === unit ? "selected" : ""
              }`}
              key={index}
              onClick={(e) => handleSelect(option, e)}
              ref={option === unit ? selectedRef : null}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const InputDayOrHourInt = ({ initialValue = 0, setValue }) => {
  const [timeUnit, setTimeUnit] = useState("Horas");
  const [number, setNumber] = useState(0);

  // Initialize component with the provided initialValue (integer)
  useEffect(() => {
    const totalHours = Number(initialValue);
    if (totalHours % 24 === 0 && totalHours !== 0) {
      setNumber(totalHours / 24);
      setTimeUnit("Dias");
    } else {
      setNumber(totalHours);
      setTimeUnit("Horas");
    }
  }, [initialValue]);

  // Update parent component whenever number or timeUnit changes
  useEffect(() => {
    const totalHours = timeUnit === "Dias" ? number * 24 : number;
    setValue(totalHours);
  }, [number, timeUnit, setValue]);

  const handleChange = (e) => {
    const value = Number(e.target.value);
    if (!isNaN(value) && value >= 0) {
      setNumber(value);
    } else if (e.target.value === "") {
      setNumber(0);
    }
  };

  return (
    <div style={{ display: "flex", flexWrap: "nowrap" }}>
      <Input
        type="number"
        id="number_of_babychairs"
        name="number_of_babychairs"
        value={number}
        min={0}
        onChange={handleChange}
      />
      <DropDownButton
        options={["Dias", "Horas"]}
        unit={timeUnit}
        setUnit={setTimeUnit}
      />
    </div>
  );
};

export default InputDayOrHourInt;
